/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React from 'react';

import { RoundedColorSelect } from './RoundedColorSelect';
import { useTestPatientNameList } from '../../TestPatients/testPatients';
import styles from './FhirPatientComponent.module.scss';

interface AzureFhirPatientSelectProps {
  azureFilename: string;
  onAzureFilenameChange: (azureFilename: string | undefined) => void;
  onClick?: (e: React.MouseEvent) => void; // Optional handler for shift-click events
  createNewOption?: boolean;
  showDevPatients?: boolean;
}

export function AzureFhirPatientSelect({
  azureFilename,
  onAzureFilenameChange, // Called with __create__ to mean create new patient
  createNewOption,
  showDevPatients,
  onClick,
}: AzureFhirPatientSelectProps) {
  const { patientNames } = useTestPatientNameList(!!showDevPatients);
  return (
    <RoundedColorSelect
      id="patientContextMRN"
      value={azureFilename}
      onChange={(e) => onAzureFilenameChange(e?.target.value)}
      items={patientNames?.map((x) => ({ id: x, name: x })) || [{ id: '', name: azureFilename }]}
      className={styles.patientMRNSelects}
      nullValue={<div className={styles.defaultListItem}>None</div>}
      placeholder={<div className={styles.selectPlaceholder}>Select Test Patient</div>}
      createNewOption={createNewOption ? 'Create New Patient...' : undefined}
      infoText={'Test patients simulate EMR integration capability across the library.'}
      readonly={!patientNames}
      onClick={onClick}
    />
  );
}
